export var BreadcrumbsDelta;
(function (BreadcrumbsDelta) {
    /**
     * Type of delta event.
     */
    let type;
    (function (type) {
        type["BREADCRUMBS_DELTA"] = "breadcrumbs_delta";
    })(type = BreadcrumbsDelta.type || (BreadcrumbsDelta.type = {}));
})(BreadcrumbsDelta || (BreadcrumbsDelta = {}));
